import { render, staticRenderFns } from "./AddContentToUserGroupChild.vue?vue&type=template&id=50376e51&scoped=true&lang=html&"
import script from "./AddContentToUserGroupChild.vue?vue&type=script&lang=js&"
export * from "./AddContentToUserGroupChild.vue?vue&type=script&lang=js&"
import style0 from "./AddContentToUserGroupChild.vue?vue&type=style&index=0&id=50376e51&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50376e51",
  null
  
)

export default component.exports